export async function detectImageMime(file) {
    if (file.type && file.type.startsWith("image/")) {
        return file.type;
    }

    const buffer = await file.slice(0, 4100).arrayBuffer();
    const bytes = new Uint8Array(buffer);

    const isPng = bytes.length >= 8
        && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4E && bytes[3] === 0x47
        && bytes[4] === 0x0D && bytes[5] === 0x0A && bytes[6] === 0x1A && bytes[7] === 0x0A;
    if (isPng) {
        return "image/png";
    }

    const isJpeg = bytes.length >= 3 && bytes[0] === 0xFF && bytes[1] === 0xD8 && bytes[2] === 0xFF;
    if (isJpeg) {
        return "image/jpeg";
    }

    const isWebP = bytes.length >= 12 && bytes[0] === 0x52 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x46 && bytes[8] === 0x57 && bytes[9] === 0x45 && bytes[10] === 0x42 && bytes[11] === 0x50;
    if (isWebP) {
        return "image/webp";
    }

    return null;
}